import React from 'react';
import {AutocompleteInput, Datagrid, DateInput, Filter, List, ReferenceInput, TextField, TextInput} from 'react-admin';
import {DateTimeField, schoolYears} from "../../components";

const MealRegistrationFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Tìm kiếm" source="q" alwaysOn helperText='Mã VinaID, họ và tên'/>
        <ReferenceInput label="Lớp" source="unitId" reference="baseUnits" alwaysOn allowEmpty
                        {...props}
                        filter={{schoolYear: schoolYears[0].id, isFullDay: true}}
                        sort={{field: 'name', order: 'ASC'}}
                        perPage={999}
        >
            <AutocompleteInput optionText="name" helperText={' '}/>
        </ReferenceInput>
        <DateInput label="Ngày" source="eatDate" alwaysOn allowEmpty helperText=' '/>
    </Filter>
);

export const MealRegistrationList = props => {
    return (
        <List filters={<MealRegistrationFilter/>}
              bulkActions={false}
              exporter={false}
              perPage={20}
              {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id"/>
                <TextField source="customerId"/>
                <TextField source="customerName"/>
                <TextField source="baseUnitName"/>
                <TextField source="unitName"/>
                <DateTimeField source="eatDate" format="DD-MM-YYYY"/>
                <TextField source="regisFoodMenuName"/>
                <TextField source="takenFoodMenuName"/>
                <TextField source="changedFoodMenuName"/>
            </Datagrid>
        </List>
    )
}

export default MealRegistrationList
